import React from "react";
import Modal from "react-modal";
import "../styles/statusBar.css";
import {
  parseIncomingData,
  parseDate,
  getStepFromStatus,
} from "../utils/Miscellaneous";

Modal.setAppElement("#root");

export const ModalContentDetails = ({
  transactionArray,
  closeModal,
  currentFlowStep,
}) => {
  // Ensure transactionArray is defined and is an array
  const validTransactionArray = Array.isArray(transactionArray)
    ? transactionArray
    : [];

  // Debug: Log the input data for transactions and current flow step
  console.log("Transaction Array: ", validTransactionArray);
  console.log("Current Flow Step: ", currentFlowStep);

  // Filter transactions by step using the currentFlowStep prop
  const relevantTransactions = validTransactionArray.filter((transaction) => {
    const boomiStatus = transaction?.boomiStatus;
    const mappedStep = getStepFromStatus(boomiStatus);

    // Debug: Log the boomiStatus and the step mapped from it
    console.log(
      `Transaction boomiStatus: ${boomiStatus}, Mapped Step: ${mappedStep}`
    );

    // Ensure boomiStatus is defined before comparing
    return boomiStatus && mappedStep === currentFlowStep;
  });

  // Debug: Log the filtered transactions
  console.log("Relevant Transactions: ", relevantTransactions);

  // Safely retrieve the first valid execution URL
  const firstExecutionUrl = relevantTransactions.find(
    (transaction) => transaction.boomiExecutionUrl
  )?.boomiExecutionUrl;

  // Function to render the content of each transaction
  const renderTransactionContent = (transaction) => {
    return (
      <div key={transaction.documentIdentifier || transaction.id}>
        <div className="log">{parseIncomingData(transaction.incomingData)}</div>
        {transaction?.additionalRemark && (
          <div>
            <strong>Remarks: </strong>
            {parseIncomingData(transaction.additionalRemark)}
          </div>
        )}
        {(Boolean(transaction?.acknowledged) && transaction.acknowledgementData) && (
          <div>
            <strong>Acknowledgement: </strong>
            <div className="log">
              {" "}
              {parseIncomingData(transaction.acknowledgementData)}
            </div>
          </div>
        )}

        <div>
          <strong>Date: </strong>
          {parseDate(transaction?.DateTime)}
        </div>
        {/Error/.test(transaction?.boomiStatus) && (
          <>
            <div className="error-reason">Error Reason</div>
            <div className="error-reason">
              {parseIncomingData(transaction.errorReason)}
            </div>
          </>
        )}
      </div>
    );
  };

  return (
    <Modal
      isOpen={true}
      onRequestClose={closeModal}
      contentLabel="Transaction Data"
    >
      <div>
        <h3>{currentFlowStep} Transactions</h3>
        {relevantTransactions.length > 0 ? (
          relevantTransactions.map(renderTransactionContent)
        ) : (
          <div>No {currentFlowStep?.toLowerCase()} transactions available</div>
        )}
        {firstExecutionUrl && (
          <div className="log">
            <a
              href={firstExecutionUrl.match(/https?:\/\/[^\s'"]+/)?.[0] || "#"}
              target="_blank"
              rel="noopener noreferrer"
            >
              <strong>Boomi Execution Url</strong>
            </a>
          </div>
        )}
      </div>
      <button className="modal-close-button" onClick={closeModal}>
        Close
      </button>
    </Modal>
  );
};

export default ModalContentDetails;
